export enum TripRequestLogSource {
    PLATFORM = 'platform',
    API = 'api',
}
